import PropTypes from 'prop-types';

export const PROVIDER_TYPE = {
  SURVEY_JS: 'surveyJs',
  PDF: 'pdf',
};

const propType = {
  _id: PropTypes.string,
  providerType: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  owner: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  providerData: PropTypes.shape({}),
};

export default { propType };
